export const ADMINISTRATORS_GROUP = 'Administrators';
export const ALL_ROCKMAKER_USERS = 'AllRockMakerUsers';
export const EDIT_PROTECTED_GROUP_NAMES = [ADMINISTRATORS_GROUP, ALL_ROCKMAKER_USERS];
